import { render } from "./Example.vue?vue&type=template&id=06b706ec&ts=true"
import script from "./Example.vue?vue&type=script&lang=ts"
export * from "./Example.vue?vue&type=script&lang=ts"

import "./Example.vue?vue&type=style&index=0&id=06b706ec&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__